<template>
  <b-card class="shadow" style="min-height: 700px; position: relative;">
    <!-- Loading -->
    <div v-if="loading" class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h5 class="mb-0 text-gray-800">
            Templates Dinâmicos
          </h5>

          <div>
            <b-button
              variant="outline-dark"
              :class="viewFilters ? 'active' : ''"
              @click="viewFilters = !viewFilters"
            >
              <i class="fas fa-filter"></i> Filtros
            </b-button>
          </div>
        </div>
      </div>

      <!-- FILTROS -->
      <div class="col-12" v-if="viewFilters">
        <div class="row">
          <div class="col-md-4">
            <label>Nome do CSS</label>
            <input
              type="text"
              class="form-control"
              v-model="filtroNome"
              placeholder="Ex: tema-azul"
            />
          </div>

          <div class="col-md-2">
            <label>Ativo</label>
            <select class="form-control" v-model="filtroAtivo">
              <option value="">Todos</option>
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </select>
          </div>
        </div>

        <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
          <div class="col-auto px-2 text-right">
            <button
              type="button"
              class="btn btn-secondary"
              @click.prevent="limparFiltros"
            >
              Limpar Filtros
            </button>

            <button
              class="btn btn-success btn-submit"
              type="button"
              @click="getTemas"
            >
              <i class="fas fa-search"></i> Buscar
            </button>
          </div>
        </div>
      </div>

      <!-- TABELA -->
      <div class="col-12 mt-3">
        <b-table
          :fields="campos"
          :items="temas"
          primary-key="id"
          striped
          hover
          responsive
          small
          outlined
          show-empty
        >
          <!-- AÇÕES -->
          <template #cell(actions)="data">
            <b-button
              variant="primary"
              size="sm"
              @click="editarTema(data.item)"
            >
              <i class="mdi mdi-eye"></i>
            </b-button>
          </template>

          <!-- ATIVO -->
          <template #cell(ativo_sn)="data">
            <span
              class="badge"
              :class="data.item.ativo_sn === 'S'
                ? 'badge-success'
                : 'badge-secondary'"
            >
              {{ data.item.ativo_sn }}
            </span>
          </template>

          <template #cell(usuario_nome)="data">
            {{ (data.item.usuario_nome) }}
          </template>

          <!-- DATAS -->
          <template #cell(created_at)="data">
            {{ formatarDataHora(data.item.created_at) }}
          </template>

          <template #cell(updated_at)="data">
            {{ formatarDataHora(data.item.updated_at) }}
          </template>

          <!-- EMPTY -->
          <template #empty>
            <div class="text-center my-5">
              <i class="mdi mdi-palette-outline" style="font-size: 80px;"></i>
              <h5 class="mt-3">Nenhum tema encontrado</h5>
            </div>
          </template>
        </b-table>

        <!-- PAGINAÇÃO -->
        <div class="d-flex justify-content-between align-items-center mt-3">
          <div>
            <select
              class="form-control d-inline-block"
              style="width: 80px"
              v-model="perPage"
              @change="getTemas"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
          </div>

          <b-pagination
            v-model="page"
            :per-page="perPage"
            :total-rows="pagination.total"
            @change="getTemas"
          />
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import axios from "axios";

export default {
  name: "TemaDinamico",
  data() {
    return {
      viewFilters: true,
      filtroNome: "",
      filtroAtivo: "",
      temas: [],
      page: 1,
      perPage: 10,
      pagination: { total: 0 },
      loading: false,
      campos: [
        { key: "actions", label: "", thStyle: { width: "60px" } },
        { key: "nome_tema", label: "Nome do CSS" },
        { key: "ativo_sn", label: "Ativo", thStyle: { width: "90px" } },
        { key: "usuario_nome", label: "Usuário" },
        { key: "created_at", label: "Inclusão" },
        { key: "updated_at", label: "Alteração" },
      ],
    };
  },
  methods: {
    limparFiltros() {
      this.filtroNome = "";
      this.filtroAtivo = "";
      this.page = 1;
      this.getTemas();
    },

    novoTema() {
      this.$router.push({ name: 'NovoTemaDinamico' });
    },

     editarTema(item) {
      this.$router.push({
        name: "EditarTemaDinamico",
        params: { id: item.id },
      });
    },

    async getTemas() {
      this.loading = true;
      try {
        const { data } = await axios.get(
          "/api/dashboard/admin/listar-temas-dinamicos",
          {
            params: {
              nome_tema: this.filtroNome,
              ativo_sn: this.filtroAtivo,
              page: this.page,
              per_page: this.perPage,
            },
          }
        );

        this.temas = data.data || data;
        this.pagination.total = data.total || this.temas.length;
      } catch (err) {
        console.error("Erro ao carregar temas:", err);
      } finally {
        this.loading = false;
      }
    },

    formatarDataHora(data) {
      if (!data) return "-";

      const d = new Date(data);

      if (isNaN(d.getTime())) return "-";

      return d.toLocaleString("pt-BR", {
        dateStyle: "short",
        timeStyle: "short",
      });
    }

  },
  mounted() {
    this.getTemas();
  },
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
</style>
